import { FormErrors } from "../types";

const hasErrors = (errors: FormErrors): boolean =>
  Object.keys(errors).length !== 0;

export { hasErrors };
